"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactSvg = require("react-svg");
var _get = _interopRequireDefault(require("lodash/get"));
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
var _Modal = _interopRequireDefault(require("../../Atoms/Modal"));
var _ExperienceFooter = _interopRequireDefault(require("../ExperienceFooter"));
require("./SocialLinksFooter.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SocialLinksFooter = function SocialLinksFooter(socialFooterData) {
  var experienceFooterData = socialFooterData.experienceFooterData,
    appHostPath = socialFooterData.appHostPath,
    contactSupportHref = socialFooterData.contactSupportHref,
    isVisibleContactWatersLink = socialFooterData.isVisibleContactWatersLink;
  var socialLinks = (0, _get.default)(socialFooterData, ['socialLinks'], undefined);
  var watersLogo = (0, _get.default)(socialFooterData, ['logoImage', 'fileReference'], '');
  var logoLink = (0, _get.default)(socialFooterData, 'logoLink', '/');
  var weChatIcon = (0, _get.default)(socialFooterData, 'weChatIcon', '');
  var weChatQrCodeImage = (0, _get.default)(socialFooterData, ['weChatQrCodeImage', 'fileReference'], '');
  var _useState = (0, _react.useState)(false),
    open = _useState[0],
    setOpen = _useState[1];
  var showWechatModal = function showWechatModal(e) {
    e.preventDefault();
    setOpen(true);
  };
  var handleClose = function handleClose() {
    return setOpen(false);
  };
  var svgProps = {
    afterInjection: function afterInjection(error, svg) {
      try {
        if (error) {
          console.error(error);
          return;
        }
        var styleTag = svg.getElementsByTagName('style')[0];
        styleTag && svg.removeChild(styleTag);
      } catch (e) {
        console.error(e);
      }
    }
  };
  return _react.default.createElement("div", {
    className: "socialLinksFooter"
  }, socialFooterData && _react.default.createElement("div", {
    className: "socialLinksFooter container"
  }, _react.default.createElement("div", {
    className: "cmp-footer__linksdiv"
  }, _react.default.createElement("div", {
    className: "cmp-footer__parsys"
  }, !socialFooterData.hideNavigation && _react.default.createElement(_ExperienceFooter.default, experienceFooterData))), watersLogo && _react.default.createElement("div", {
    className: "cmp-footer__logo"
  }, _react.default.createElement(_Anchor.default, {
    elementLocator: "footer-waters-logo-link",
    to: logoLink
  }, _react.default.createElement(_reactSvg.ReactSVG, (0, _extends2.default)({}, svgProps, {
    src: "" + appHostPath + watersLogo,
    "data-locator": "footer-waters-logo"
  })))), isVisibleContactWatersLink && contactSupportHref && _react.default.createElement("div", {
    className: "contact-waters-link"
  }, _react.default.createElement(_Anchor.default, {
    to: contactSupportHref,
    className: "cmp-button primary dark",
    role: "button"
  }, socialFooterData.labels.contactSupportLinkLabel || '')), socialLinks && _react.default.createElement("div", {
    className: "cmp-footer__social-links"
  }, _react.default.createElement("div", {
    className: "social-links-text"
  }, socialFooterData.labels.followChannels), _react.default.createElement("ul", null, Object.keys(socialLinks).map(function (item) {
    return _react.default.createElement(_react.default.Fragment, null, socialLinks[item].link && socialLinks[item].linkIcon && _react.default.createElement("li", {
      className: "cmp-footer__social-links__item",
      key: item
    }, _react.default.createElement(_Anchor.default, {
      target: "_blank",
      to: socialLinks[item].link,
      className: "cmp-footer-social-links__link",
      elementLocator: socialLinks[item].link
    }, _react.default.createElement("span", {
      className: "visually-hidden"
    }, socialLinks[item].linkIcon), _react.default.createElement(_reactSvg.ReactSVG, {
      src: "" + appHostPath + socialLinks[item].linkIcon,
      wrapper: "span"
    }))));
  }), weChatIcon && weChatQrCodeImage && _react.default.createElement("li", {
    className: "cmp-footer__social-links__item"
  }, _react.default.createElement(_Anchor.default, (0, _extends2.default)({
    className: "cmp-footer-social-links__link cmp-footer__social-links__item--wechat",
    elementLocator: "cmp-footer-social-links__wechat"
  }, {
    onClick: showWechatModal
  }), _react.default.createElement("span", {
    className: "visually-hidden"
  }, weChatIcon), _react.default.createElement(_reactSvg.ReactSVG, {
    src: "" + appHostPath + weChatIcon,
    wrapper: "span"
  })))))), _react.default.createElement(_Modal.default, (0, _extends2.default)({
    className: "modal__Content",
    isOpen: open,
    headingStyle: "cmp-modal__header"
  }, {
    onRequestClose: handleClose
  }, {
    elementLocator: "cmp-wechat-modal__QrCodeImage",
    heading: socialFooterData.labels.wechatTitle,
    innerContentClassName: "cmp-wechat-modal__QrCodeImage"
  }), _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
    className: "cmp-wechat-modal__image"
  }, _react.default.createElement("img", {
    src: weChatQrCodeImage,
    alt: socialFooterData.labels.wechatQrImgAlt
  })), socialFooterData.labels.wechatText && _react.default.createElement("div", {
    className: "cmp-wechat-modal__text"
  }, socialFooterData.labels.wechatText))));
};
var _default = SocialLinksFooter;
exports.default = _default;
module.exports = exports["default"];